import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { CreateGigTab, GigPageTab } from "../constants/GigPage";

export interface createGigPageState {
  activeTab?: GigPageTab;
  activeCreateGigTab: CreateGigTab;
}

const initialState: createGigPageState = {
  activeCreateGigTab: CreateGigTab.CategoryTab,
};

export const createGigPageSlice = createSlice({
  name: "gigPage",
  initialState,
  reducers: {
    setActiveTab: (state, action: PayloadAction<GigPageTab>) => {
      state.activeTab = action.payload;
    },
    setActiveCreateGigTab: (state, action: PayloadAction<CreateGigTab>) => {
      state.activeCreateGigTab = action.payload;
    },
  },
});

export const { setActiveTab, setActiveCreateGigTab } =
  createGigPageSlice.actions;

export default createGigPageSlice.reducer;
